export default __webpack_public_path__ + "static/media/2006.65fe0a6d.png";